document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.anchor-bar')) {
    let items = [...document.querySelectorAll('[data-wf-nav-title]')].map((section) => 
      `<li class="nav-item">
        <a class="nav-link" href="#${section.getAttribute('id')}">${section.getAttribute('data-wf-nav-title')}</a>
      </li>`
    );
    document.querySelectorAll('.anchor-bar .nav').forEach((bar) => {
      bar.innerHTML = items.join('');
    })
  }
})